document.addEventListener('DOMContentLoaded', function () {

  /* =========================
   CONFIG (da schema)
  ========================= */

  const CFG = window.CART_MULTIPLE_CONFIG || {};

  /* =========================
   CHECKOUT CONTROL
  ========================= */

  function getCheckoutButtons() {
    return document.querySelectorAll('button[name="checkout"], #CheckOut');
  }

  function disableCheckout(disable) {
    getCheckoutButtons().forEach(btn => {
      btn.disabled = disable;
      btn.classList.toggle('disabled-checkout-js', disable);
    });
  }

  /* =========================
   FORMAT DETECTION
   Restituisce il formato solo se il prodotto ha varianti significative.
   Se non ha varianti (box, prodotti singoli) → restituisce null.
  ========================= */

  function getItemFormat(item) {
    // Nessuna variante o variante unica "Default Title" → prodotto senza formato
    if (
      !item.variant_options ||
      item.variant_options.length === 0 ||
      (item.variant_options.length === 1 && item.variant_options[0].toLowerCase() === 'default title')
    ) {
      return null; // ← box o prodotto singolo, escluso dalla validazione
    }

    const values = item.variant_options.join(' ').toLowerCase();
    if (values.includes('33')) return '33';
    if (values.includes('150')) return '150';
    if (values.includes('75')) return '75';

    return null; // variante non riconosciuta → escluso per sicurezza
  }

  /* =========================
   CART ROW HELPERS
  ========================= */

  function getCartItemRow(item) {
    return document.querySelector(`[data-id*="${item.variant_id}"]`);
  }

  function clearItemWarning(row) {
    if (!row) return;
    const w = row.querySelector('.cart-line-warning');
    if (w) w.remove();
  }

  function showItemWarning(row, message) {
    if (!row) return;
    const variantEl = row.querySelector('.cart-item__variant');
    if (!variantEl) return;
    let warning = row.querySelector('.cart-line-warning');
    if (!warning) {
      warning = document.createElement('div');
      warning.className = 'cart-line-warning';
      warning.style.marginTop = '6px';
      warning.style.padding = '8px 12px';
      warning.style.background = '#f8d7da';
      warning.style.color = '#842029';
      warning.style.fontSize = '13px';
      warning.style.borderRadius = '4px';
      warning.style.lineHeight = '1.4';
      variantEl.insertAdjacentElement('afterend', warning);
    }
    warning.innerText = message;
  }

  /* =========================
   CART VALIDATION
  ========================= */

  async function checkCartMultiples() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();

      let qty33 = 0;
      let qty75 = 0;

      // 1️⃣ conteggio — solo prodotti CON varianti formato riconosciuto
      cart.items.forEach(item => {
        const format = getItemFormat(item);
        if (format === '33') qty33 += item.quantity;
        if (format === '75') qty75 += item.quantity;
      });

      let blockCheckout = false;

      // 2️⃣ validazione per riga
      cart.items.forEach(item => {
        const row = getCartItemRow(item);
        clearItemWarning(row);

        const format = getItemFormat(item);

        // Nessun formato → box o singolo → nessun warning
        if (!format) return;

        if (format === '33' && qty33 > 0 && qty33 % 12 !== 0) {
          showItemWarning(
            row,
            CFG.warning33 || 'Questo prodotto da 33 cl deve essere acquistato in multipli di 12.'
          );
          blockCheckout = true;
        }

        if (format === '75' && qty75 > 0 && qty75 % 6 !== 0) {
          showItemWarning(
            row,
            CFG.warning75 || 'Questo prodotto da 75 cl deve essere acquistato in multipli di 6.'
          );
          blockCheckout = true;
        }
      });

      disableCheckout(blockCheckout);

    } catch (err) {
      console.error('Errore controllo carrello:', err);
    }
  }

  /* =========================
   EVENTS
  ========================= */

  checkCartMultiples();

  document.addEventListener('cart:updated', checkCartMultiples);
  document.addEventListener('cart.updated', checkCartMultiples);
  document.addEventListener('cart:change', checkCartMultiples);

  setInterval(checkCartMultiples, 800);

});